import { ArrowBack } from '@mui/icons-material'
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Skeleton, Typography } from '@mui/material'
import { Tabs } from './tabs/Index'
import { Preview } from './Preview'
import { useContext } from 'react'
import { ToolContext } from '../../../../../core/context/ToolContext'
import { useHistory } from 'react-router-dom/cjs/react-router-dom'
import { useEffect } from 'react'
import { rqx } from '../../../../../core/request/API'
import { env } from '../../../../../core/Env'
import { S3 } from '../../../../../core/transmit/S3'
import { SnakeLoader } from '../../../../../core/loader/SnakeLoader'
import { toPng } from 'html-to-image';

export const CustomPoster = () => {
    const { marketing_camp, tool_state } = useContext(ToolContext)
    const { form, selectedTemplate, posterList, formLoader, job, required } = marketing_camp
    const { __SESSION, userId } = tool_state
    const inputs = form.data
    const history = useHistory()
    const urlParams = new URLSearchParams(window.location.search)
    
    const handlerBack = () => {
        history.push(`/campaign/poster`)
    }
    
    const handlerTopBtn = (type) => {
        const missingFields = [];
        const qualification_array = inputs.qualification.some(v => v.stat)
        const required_fields = [
            "tagline",
            "work_location",
            "job_vacancy",
            "poster_name",
        ]
        if (inputs.company_logo.type === 'default') missingFields.push('company_logo');
        if (inputs.qualification.some(v => v.stat)) missingFields.push('qualification');

        let errors = {};
        required_fields.forEach(field => {
            if (inputs.with_job_acc && field === 'job_vacancy') {
                if (!inputs[field] || inputs[field].toString().trim() === "") {
                    errors[field] = `${field} is required.`;
                    missingFields.push(field)
                }
            }else{
                if (!inputs[field] || inputs[field].trim() === "") {
                    errors[field] = `${field} is required.`;
                    missingFields.push(field)
                }
            }
        })
        const default_images = inputs.company_logo.type === 'default';
       
        if (Object.keys(errors).length > 0 || qualification_array || default_images) {
            console.log("Validation failed:", missingFields, qualification_array ? 'qualification' : default_images ? 'default_images' : errors);
            required.set(missingFields)
            form.set({...form.data, error : true})
        }else{
            required.set([])
            form.set({...form.data, saving_type : type, error : false, confirmation : true })
        }
        
    }
    
    const handlerConfirmation = async() => {
        form.set({...form.data, loader: true})
        // CONVERTING HTML DESIGN TO IMAGE
        const preview_image = document.getElementById('preview');
        const imgs = preview_image.querySelectorAll('img'); // get all images from preview_image element

        for (const img of imgs) {
            if (img.src.startsWith("blob:") || img.src.startsWith("data:")) continue; // skip blob:// or data:// URLs
            if (img && img.src) {
        const baseUrl = img.src.split('?')[0]; // remove any old params
            img.crossOrigin = 'anonymous'; // important for html-to-image
            img.src = `${baseUrl}?v=${Date.now()}`; // cache-busting param
            await new Promise((resolve, reject) => { // await for each image to reload before continuing
            img.onload = resolve;
            img.onerror = reject;
        });
        }
        }
        const dataUrl = await toPng(preview_image, {
            quality: 1,
            pixelRatio: 2,
        });
        
        const x = await fetch(dataUrl, {method: 'GET', headers: { "Cache-Control": 'no-cache' } });
        const blob = await x.blob();

        const fileName = `${inputs.poster_name}.png`;
        const file = new File([blob], fileName, { type: blob.type });

        const poster_link = await S3([file])
    
        let company_logo = inputs.company_logo.value
        let ft_image = inputs.ft_image.value
        let bg_image = inputs.bg_image.value
        if (inputs.company_logo.object !== '') {
            company_logo = await S3(Array(inputs.company_logo.value))
        }
        let features_image;
        if (inputs.ft_image.object !== '') {
            if (inputs.ft_image.value !== 'default_logo') {
                ft_image = await S3(Array(inputs.ft_image.value))
                features_image = {value: ft_image.location, object: "", name: inputs.ft_image.name, size: inputs.ft_image.size, type: inputs.ft_image.type }
            }else{
                features_image = {"value": "default_logo", "object": "https://marketing-system-repo.s3.amazonaws.com/mt/phases/1757390146997.png", "name": "image 17.png", "type": "default", "size": 81516}
            }
        }
        let violator_image;
        if (inputs.violator) {
            let v_image = inputs.violator_image.value
            const validate_violator_default = inputs.violator_image.object !== "https://marketing-system-repo.s3.amazonaws.com/mt/phases/1753766821543.png"
            if (validate_violator_default) {
                v_image = await S3(Array(inputs.violator_image.value))
                console.log(v_image)
            }
            violator_image = {value: validate_violator_default ? v_image.location : inputs.violator_image.value, object: validate_violator_default ? "" : "https://marketing-system-repo.s3.amazonaws.com/mt/phases/1753766821543.png", name: inputs.violator_image.name, size: inputs.violator_image.size, type: inputs.violator_image.type }
        }else{
            violator_image = {value: "default_logo", object: "https://marketing-system-repo.s3.amazonaws.com/mt/phases/1753766821543.png", name: "vector_img.png", size: 289, type: "default" }
        }
        let background_image;
        if (inputs.bg_image.object !== '') {
            if (inputs.bg_image.value !== 'default_logo') {
                bg_image = await S3(Array(inputs.bg_image.value))
                background_image = {value: bg_image.location, object: "", name: inputs.bg_image.name, size: inputs.bg_image.size, type: inputs.bg_image.type }
            }else{
                background_image = {value: "default_logo", object: "https://marketing-system-repo.s3.amazonaws.com/mt/phases/1753782085010.png", name: "Group 57799.png", size: 289, type: "default" }
            }
        }
        
        const content_desgin = {
            "data_source": inputs.with_job_acc ? "job" : "manual",
            "company_logo": {value:  inputs.company_logo.object !== '' ? company_logo.location : inputs.company_logo.value, object: "", name: inputs.company_logo.name, size: inputs.company_logo.size, type: inputs.company_logo.type },
            "company_name": inputs.company_name,
            "company_name_color": inputs.company_name_color,
            "tagline": inputs.tagline,
            "tagline_color": inputs.tagline_color,
            "work_location": inputs.work_location,
            "location_color": inputs.location_color,
            "with_job_acc": inputs.with_job_acc,
            "job_vacancy": inputs.job_vacancy,
            "job_vacancy_color": inputs.job_vacancy_color,
            "qualification": inputs.qualification,
            "qualification_bg": inputs.qualification_bg,
            "qualification_list_color": inputs.qualification_list_color,
            "qualification_text_color": inputs.qualification_text_color,
            "ft_image": features_image,
            "violator": inputs.violator,
            "violator_image": violator_image,
            "bg_image": background_image,
            "poster_name": inputs.poster_name,
        }
        const body = {
            'company_id': __SESSION.data.uaccess[0].company_id,
            'template_id': selectedTemplate.data.id,
            'poster_name': inputs.poster_name,
            'content_design': content_desgin,
            'user_id': userId.data,
            "status": inputs.saving_type === 'Save' ? 1 : 2,
            "poster_link": poster_link.location,
            "id": inputs.method === 'update' ? inputs.id : ""
        }
        const res = await rqx.post(`<<tool>>/${env()}/marketing_campaign/${inputs.method}`, body)
        if (res.message === 'success') {
            form.set({...form.data, confirmation: false, error: false, loader: false, method: 'create', saving_type: '', with_job_acc: false, violator: false, })
            if (inputs.method === 'create') {
                posterList.set((prev) => [
                    {
                        id: res.poster_id,
                        status: inputs.saving_type === 'Save' ? 1 : 2,
                        poster_link: poster_link.location
                    },
                    ...prev
                ])
            }else{
                posterList.set(posterList.data.map(v => 
                    parseInt(v.id) === parseInt(urlParams.get('pid')) ?
                        {...v, status: inputs.saving_type === 'Save' ? 1 : 2, poster_link: poster_link.location}
                    :
                        {...v}
                ))
            }
            history.push('/campaign/poster')
        }
    }
    
    const readPoster = async() => {
        formLoader.set(true)
        const r = await rqx.get(`<<tool>>/${env()}/marketing_campaign/posterTemplate`, {id: urlParams.get('id')})
        if (r) {
            if (urlParams.get('job_id')) {
                const j = await rqx.get(`<<tool>>/${env()}/marketing_campaign/job_vacancy`, {company_id: __SESSION.data.uaccess[0].company_id })
                const q = await rqx.get(`<<tool>>/${env()}/marketing_campaign/job_qualification`, {job_id: urlParams.get('job_id')})
                const updateQ = q.map(item => ({
                    ...item, stat : false, msg: ''
                }))
                job.set({list : j, qualification : updateQ})
                const d = JSON.parse(r[0].designs)
                d.job_vacancy = parseInt(urlParams.get('job_id'))
                form.set({...form.data, method: 'create', with_job_acc : true, ...d})
                selectedTemplate.set(r[0])
                formLoader.set(false)
            }else{
                const d = JSON.parse(r[0].designs)
                form.set({...form.data, method: 'create', ...d})
                selectedTemplate.set(r[0])
                formLoader.set(false)
            }
        }
    }
    
    const viewPoster = async () => {
        form.set({ confirmation: false, error: false, loader: false, method: 'create', saving_type: '', with_job_acc: false, violator: false, })
        formLoader.set(true)
        const v = await rqx.get(`<<tool>>/${env()}/marketing_campaign/viewPoster`, {id: urlParams.get('pid')})
        if (v) {
            const cd = JSON.parse(v[0].content_design)
            form.set({ method: 'update', id: v[0].id, ...cd})
            selectedTemplate.set(v[0])
            if (cd.with_job_acc){
                const r = await rqx.get(`<<tool>>/${env()}/marketing_campaign/job_vacancy`, {company_id: __SESSION.data.uaccess[0].company_id })
                const q = await rqx.get(`<<tool>>/${env()}/marketing_campaign/job_qualification`, {job_id: cd.job_vacancy})
                const updateQ = q.map(item => ({
                    ...item, stat : false, msg: ''
                }))
                job.set({list : r, qualification : updateQ})
            }
            formLoader.set(false)
        }
    }
        
    useEffect(() => {
        if (selectedTemplate.data === null && urlParams.get('id')) {
            readPoster()
        }
        if (urlParams.get('pid')) {
            viewPoster()
        }
        // eslint-disable-next-line
    },[])
    
    return (
        <Box height="100%" display="flex" flexDirection="column" className="overflowY">
            {
                formLoader.data ?
                    <>
                        <Box display="flex" justifyContent="space-between" p="16px" boxShadow={1}>
                            <Skeleton variant="rounded" height={30} width={100} />
                            <Box display="flex" gap="16px">
                                <Skeleton variant="rounded" height={37} width={145} />
                                <Skeleton variant="rounded" height={37} width={145} />
                            </Box>
                        </Box>
                        <Box height="100%" width="100%" display="flex" className="overflowY">
                            <Box height="100%" width={500} boxShadow={1}>
                            <Skeleton variant='rounded' height="100%" />
                            </Box>
                            <Box height="100%" width="100%" p="32px" className="overflowY">
                                <Skeleton variant='rounded' height="100%" />
                            </Box>
                        </Box>
                    </>
                :   
                    <>
                        <Box display="flex" justifyContent="space-between" p="16px" boxShadow={1}>
                            <IconButton onClick={handlerBack} sx={{ border: '2px solid #003F2E', ':hover': { bgcolor: '#edf3eeff' }}}>
                                <ArrowBack sx={{color: '#003022', fontSize: 24}} />
                            </IconButton>
                            <Box display="flex" gap="16px">
                                <Box component={Button} variant="contained" bgcolor="#009F4D" color="#fff" width={145} onClick={() => handlerTopBtn('Save')}
                                    sx={{':hover': { bgcolor:"#009F4D", color:"#fff" } }}
                                >
                                    Save
                                </Box>
                                <Box component={Button} variant="contained" bgcolor="#0876F8" color="#fff" width={145} onClick={() => handlerTopBtn('Post')}
                                    sx={{':hover': { bgcolor:"#0876F8", color:"#fff" } }}
                                >
                                    Post
                                </Box>
                            </Box>
                        </Box>
                        <Box height="100%" width="100%" display="flex" className="overflowY">
                            <Box height="100%" width={500} boxShadow={1}>
                                <Tabs marketing_camp={marketing_camp} __SESSION={__SESSION} />
                            </Box>
                              <Box height="100%" width="100%" py="32px" className="overflowY">
                                <Preview marketing_camp={marketing_camp}/>
                            </Box>
                        </Box>
                    </>
            }
            {/* CONFIRMATION MODAL SAVING */}
            <Dialog open={inputs.confirmation} onClose={() => form.set({...form.data, confirmation : false})}>
                <DialogTitle sx={{ fontSize: '18px', fontWeight: 600 }}>Confirm {inputs.saving_type}</DialogTitle>
                <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                    <Typography sx={{ fontSize: '14px', fontWeight: 400 }}>Are you sure you want to {inputs.saving_type} this Poster?</Typography>
                </DialogContent>
                <DialogActions>
                    <Button variant="outlined" sx={{width: 80, height: 37}} onClick={() => form.set({...form.data, confirmation : false})} disabled={inputs.loader}>
                        Cancel
                    </Button>
                    <Button variant="contained" sx={{width: 80, height: 37}} onClick={handlerConfirmation} disabled={inputs.loader}>
                        {
                            inputs.loader ?
                                <SnakeLoader size="8px" bg="#ffffff" distance="0.3rem" />
                            :
                                inputs.saving_type
                        }
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    )
}
